export const locale = {
  lang: 'fr-CA',
  data: {
    ERROR_503: {
      CONTACT_US: 'Contactez nous',
      MESSAGE: 'Nous sommes en maintenance programmée.',
      // 'SUB_MESSAGE': 'Just kidding, looks like we have an internal issue, please try again in couple minutes',
      SUB_MESSAGE: 'Désolé pour le désagrément, on sera de retour sous peu !',
      REPORT_PROBLEM: 'Report this problem',
      BACK_PAGE: 'Retourner à la page précédente',
      BACK_HOME_PAGE: 'Retourner au tableau de bord',
      GT2_SITE: 'Visiter www.gestiontraiteur.com',
      SUBJECT: 'Sujet',
      SUCCESS_MESSAGE: 'Votre message a été envoyé avec succès!',
      CONTACT_MESSAGE:
        'Bien que nous avons été averti du problème automatiquement, nous apprécions toujours plus de détails sur l’erreur que vous avez reçu. Svp contactez nous.',
      RETRY: 'Réessayer',
      AUTO_CHECK: 'Vérification automatique toutes les 30 secondes...',
      HUMOR_TIP: '☕ C\'est le temps parfait pour un café... ou deux !',
    },
  },
};
